import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getRequest, postRequest, putRequest, deleteRequest } from 'utils/http'

const CAROUSEL_QUERY_KEY = 'carousel-slides'

export const getCarouselSlides = async () => {
  return await getRequest('carousel-slides')
}

export const useGetCarouselSlides = () => {
  return useQuery({
    queryKey: [CAROUSEL_QUERY_KEY],
    queryFn: getCarouselSlides,
  })
}

export const createCarouselSlide = async formData => {
  return postRequest('carousel-slides', formData)
}

export const useCreateCarouselSlide = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createCarouselSlide,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CAROUSEL_QUERY_KEY] })
    },
    onError: error => {
      console.error('Failed to create carousel slide:', error)
    },
  })
}

export const updateCarouselSlide = async formData => {
  return postRequest(`carousel-slides/${formData.get('id')}`, formData)
}

export const useUpdateCarouselSlide = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateCarouselSlide,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CAROUSEL_QUERY_KEY] })
    },
    onError: error => {
      console.error('Failed to update carousel slide:', error)
    },
  })
}

export const deleteCarouselSlide = async id => {
  return deleteRequest(`carousel-slides/${id}`)
}

export const useDeleteCarouselSlide = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteCarouselSlide,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CAROUSEL_QUERY_KEY] })
    },
    onError: error => {
      console.error('Failed to delete carousel slide:', error)
    },
  })
}

export const getCarouselHeadline = async () => {
  return await getRequest('carousel/headline')
}

export const useGetCarouselHeadline = () => {
  return useQuery({
    queryKey: ['carousel-headline'],
    queryFn: getCarouselHeadline,
  })
}

export const updateCarouselHeadline = async data => {
  return putRequest('carousel/headline', data)
}

export const useUpdateCarouselHeadline = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateCarouselHeadline,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['carousel-headline'] })
    },
    onError: error => {
      console.error('Failed to update carousel headline:', error)
    },
  })
}

